<template>
  <div class="barcode-print">
    <el-dialog title="打印预览 （标签尺寸60mm*40mm）" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="dialog-content">
        <!-- 打印内容 -->
        <div id="print-content" style="overflow-y: auto;height: 500px;">
          <div v-for="(item, index) in parintData" :key="index" class="label-print">
            <img :id="'barcodeBox-' + index" />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="print">打 印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";
export default {
  data() {
    return {
      dialogVisible: false,
      parintData: []
    }
  },
  methods: {
    open(parintData) {
      this.parintData = parintData;
      this.dialogVisible = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.createBarcode()
        }, 1000);

      });
    },
    createBarcode() {
      // 生成条形码，如果有BUG请参考https://blog.csdn.net/2303_77072102/article/details/135340614
      const options = {
        text: '', // 条形码生成的内容
        fontSize: 60, // 条形码下方的字体大小
        width: 2.5, // 条形码的宽度，是指单条黑条的宽度
        height: 100, // 条形码高度
        displayValue: true, // 是否显示条形码下方的内容
        // textAlign: 'center', // 条形码下方的内容水平对齐方式
        // textPosition: 'bottom', // 条形码下方的内容垂直对齐方式
        // textMargin: 2, // 条形码下方的内容与条形码之间的间距
        // fontOptions: '', // 条形码下方的字体样式，如加粗、斜体等
        // font: 'fantasy', // 条形码下方的字体
      }

      this.parintData.forEach((item, index) => {
        options.text = item.full_code
        JsBarcode("#barcodeBox-" + index, item.full_code, options)
      })

    },
    print() {
      // 获取打印内容的 HTML
      const printContentDiv = document.getElementById('print-content');
      const printContentHTML = printContentDiv.innerHTML;

      // 创建一个新的标签页
      const newWindow = window.open('', '_blank');

      // 构建打印内容
      let content = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>打印标签</title>
          <style>
            * {
              padding: 0;
              margin: 0;
              box-sizing: border-box;
            }
            .label-print {
              padding: 10px;
              margin: 0;
              width: 227px;
              height: 151px;
              display: flex;
              flex-direction: column;
              overflow: hidden;
              box-sizing: border-box;
            }
            img {
              margin: auto;
              width: 100%;
            }
          </style>
        </head>
        <body>
          ${printContentHTML}
          <script>
            window.onload = function() {
              window.print();
              window.close();
            };
          <\/script>
        </body>
        </html>
      `;

      // 写入内容到新标签页
      newWindow.document.write(content);
      newWindow.document.close();
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => { })
    }
  }
}
</script>

<style scoped>
.dialog-content {
  min-height: 200px;
}

.label-print {
  padding: 10px;
  margin: 0;
  display: flex;
  width: 227px;
  height: 151px;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid #ccc;
  margin-bottom: 5px;
}

img {
  margin: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/inventory/StorageLocationPrintModel.vue